/* eslint-disable react-refresh/only-export-components */
import { lazy, Suspense, useEffect } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  useRouteError
} from 'react-router';

import { BaseLayout } from '@link/emot/layouts';
import SeatSelection from '@link/emot/views/SeatSelection';
import TrainList from '@link/emot/views/TrainList';
import Confirm from '@link/emot/views/Confirm';
import Submitted from '@link/emot/views/Submitted';

const NotFound = lazy(() => import('@link/emot/views/NotFound'));

function RootErrorBoundary() {
  const error = useRouteError();
  const message = error instanceof Error ? error.message : String(error);

  useEffect(() => {
    if (message.includes('Failed to fetch dynamically imported module')) {
      location.reload();
    }
  }, [message]);

  return null;
}

const lazyView = (view: JSX.Element) => (
  <Suspense fallback="Loading...">{view}</Suspense>
);

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route errorElement={<RootErrorBoundary />}>
      <Route path="/" element={<BaseLayout />}>
        <Route index element={<TrainList />} />
        <Route path="train-list" element={<TrainList />} />
        <Route path=":token/:bookingId">
          <Route index element={<TrainList />} />
          <Route path="seat" element={<SeatSelection />} />
          <Route path="confirm" element={<Confirm />} />
          <Route path="submitted" element={<Submitted />} />
        </Route>
      </Route>
      <Route path="*" element={lazyView(<NotFound />)} />
    </Route>
  )
);

export default router;
